export default __webpack_public_path__ + "static/media/img-2.b2ab572a.png";